import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Select from '../../../../../components/Select'
import { useSroiFilters } from '../../SroiFiltersContext'

import { socialReturnOnInvestmentReportSelector } from '../../../../../modules/selectors/socialReturnOnInvestment'

import useStyles from '../styles'

const RegionsFilter = () => {
  const { selectedRegion, setSelectedRegion } = useSroiFilters()
  const { t } = useTranslation()
  const classes = useStyles()

  const report = useSelector(socialReturnOnInvestmentReportSelector)

  const formattedRegions = useMemo(() => {
    const regions = report?.regional_impact || []

    return regions.map(region => ({
      value: region.region,
      label: region.region
    }))
  }, [report])

  const onChangeHandler = useCallback(
    option => {
      setSelectedRegion(option.value)
    },
    [setSelectedRegion]
  )

  const clearInputHandler = useCallback(() => {
    setSelectedRegion(null)
  }, [setSelectedRegion])

  return (
    <Select
      className={classes.select}
      options={formattedRegions}
      isSearchable={false}
      value={selectedRegion}
      onChange={onChangeHandler}
      placeholder={t('All regions')}
      showClearInputIcon={!!selectedRegion}
      onClearInput={clearInputHandler}
    />
  )
}

export default RegionsFilter
